const zh = {
  code: "zh",
  htmlLang: "zh-CN",
  meta: {
    title: "为家人留下清晰与安心 | 遗嘱与财富传承线上讲座",
    description: "参加专为新加坡家庭而设的免费华语线上讲座，了解遗嘱、CPF 提名、遗嘱执行人与受益人角色，以及资产整理如何构成更完整的财富传承规划。",
  },
  brand: { name: "AFFINITY", small: "Infinity Financial Advisory 旗下财务顾问代表团队" },
  nav: { context: "免费 · Zoom 线上直播讲座 · 新加坡家庭适用", reserve: "立即保留席位", langLabel: "选择页面语言" },
  hero: {
    chip: "{count}场 Zoom 线上直播讲座 · 英文 {en} · 华语 {zh} · 上午10时至11时",
    title: ["家人或许能继承一切。", "唯独缺少答案。"],
    lead: "一次理清遗嘱、CPF 提名、遗嘱执行人角色与资产安排之间的关键联系，让您所爱的人在最需要的时候，不必猜测下一步该怎么走。",
    benefits: ["看懂每份文件真正发挥的作用", "发现家庭最容易忽略的传承缺口", "带走一份清晰可执行的下一步清单"],
    quickLabel: "电邮地址",
    quickPlaceholder: "输入电邮，开始报名",
    quickButton: "开始报名",
    learnLink: "看看您将在讲座中学到什么 ↓",
    micros: ["免费参加", "100% 线上（Zoom）· 无需出门", "无任何购买义务"],
    formatNote: "所有场次均为 Zoom 线上直播讲座，在家用手机、平板或电脑即可参加，并非实体活动。",
    presenterInitials: "VC",
    presenter: "华语主讲：Vincent Chua 蔡镇安（9月19日）· Fion Yong 杨炎芬（11月21日）· Affinity Group",
  },
  reflection: {
    kicker: "一个值得认真回答的问题",
    title: "如果家人明天必须替您处理一切，他们知道该从哪里开始吗？",
    options: ["知道，非常确定", "我其实不太确定"],
    prompt: "请选择最贴近您现况的答案。",
    answers: ["这是一个很好的开始。讲座将帮助您检查各项安排是否真正互相配合。", "这份不确定，正是您值得参加讲座的原因。让我们把它变成清晰可行的下一步。"],
    link: "把不确定，变成清晰的下一步 →",
  },
  credibility: [
    { icon: "SG", text: "贴近新加坡家庭的传承规划重点" },
    { icon: "1H", text: "一小时 Zoom 线上掌握重点，拒绝艰涩术语" },
    { icon: "Q", text: "真实情境解析，并设现场问答环节" },
  ],
  marquee: ["遗嘱", "CPF 提名", "遗嘱执行人与受益人", "监护人安排", "资产清单", "人生阶段检视", "新加坡家庭适用", "免费线上讲座"],
  clarity: {
    eyebrow: "真正的传承考验",
    title: "没有您在身边，家人找得到所有答案吗？",
    lead: "遗产规划不只是留下什么，更重要的是：对的人能否找得到、看得懂，并在需要时顺利行动。",
    button: "为家人建立更清晰的规划",
    mapKicker: "点击每一个关键点",
    mapTitle: "四个不该留给家人猜测的问题。",
    interactive: "互动体验",
    maps: [
      { title: "您拥有什么？", meta: "资产 · 保单 · 重要记录", message: "他们知道您的重要资产、保单和文件存放在哪里吗？", question: "assets" },
      { title: "谁应该行动？", meta: "遗嘱执行人 · 受益人 · 顾问", message: "他们知道您信任谁来协调下一步，并寻求专业协助吗？", question: "roles" },
      { title: "您的意愿是什么？", meta: "遗嘱 · 提名 · 个人意愿", message: "您的意愿是否已经通过有效文件记录，而不只是口头交代？", question: "will" },
      { title: "规划仍符合现况吗？", meta: "婚姻 · 子女 · 资产变化", message: "经历重大家庭或人生变化后，您的安排是否仍符合今天的意愿？", question: "review" },
    ],
  },
  plan: {
    eyebrow: "看见完整全貌",
    title: "遗嘱很重要，但它并不是完整的传承规划。",
    lead: "清晰的财富传承需要多项安排互相衔接。点击每个部分，看看为什么只依赖一份文件，仍可能留下关键缺口。",
    tabs: [
      { label: "遗嘱", panelLabel: "您的遗产", title: "谁能继承什么？又由谁执行您的安排？", copy: "如果没有有效遗嘱，符合资格的家属一般需要申请遗产管理书；非回教徒的遗产则会按法律规定分配。妥善拟定的遗嘱可指定受益人与遗嘱执行人。", source: "官方参考：My Legacy", href: "https://mylegacy.life.gov.sg/end-of-life-planning/write-a-will/if-you-dont-have-a-will/", prompt: "婚姻、孩子、购置房产或家庭关系改变后，您的遗嘱是否也同步更新？" },
      { label: "CPF", panelLabel: "您的 CPF 储蓄", title: "您的遗嘱无法决定 CPF 储蓄的分配。", copy: "CPF 储蓄不属于遗产，也不能通过遗嘱分配。CPF 提名让您指定谁可领取您的 CPF 储蓄，以及各自的分配比例。", source: "官方参考：CPF Board", href: "https://www.cpf.gov.sg/member/account-services/providing-for-your-loved-ones/making-a-cpf-nomination", prompt: "尤其经历重大家庭变化后，您的 CPF 提名仍然符合现况吗？" },
      { label: "定期检视", panelLabel: "您的检视周期", title: "您的规划仍符合今天的生活与意愿吗？", copy: "婚姻、离婚、生儿育女、购置房产、事业变化或家庭关系改变，都可能令旧有安排不再符合原本意愿。财富传承规划应在重大人生变化后重新检视。", source: "官方规划资源：My Legacy", href: "https://mylegacy.life.gov.sg/", prompt: "上一次检视遗嘱、提名与重要联络资料，是什么时候？" },
      { label: "资产", panelLabel: "您的资产资料", title: "家人能找到您拥有的资产吗？", copy: "当银行账户、保单、房地产、负债与重要文件分散各处，规划便难以顺利执行。一份持续更新的资产清单，能让合适的人知道从哪里开始。", source: "官方规划资源：My Legacy", href: "https://mylegacy.life.gov.sg/", prompt: "在不泄露敏感密码的前提下，您信任的人知道如何找到最新资料吗？" },
      { label: "关键人物", panelLabel: "您信任的人", title: "再完整的文件，也需要合适的人来执行。", copy: "遗嘱执行人、监护人、被提名人与受益人的角色各不相同。慎重选择，并让他们预先理解自己的责任，能减少日后的混乱与压力。", source: "官方参考：新加坡法院", href: "https://www.judiciary.gov.sg/family/probate-and-administration", prompt: "您指定的人仍愿意、适合并且能够取得联系吗？" },
    ],
    askYourself: "问问自己：",
  },
  beliefs: {
    eyebrow: "常见的想当然",
    title: "哪一句最像现在的您？",
    lead: "点击一句看看。如果听起来很熟悉，这场讲座将帮助您把“想当然”转化成更清晰、更实际的下一步。",
    assumption: "想当然",
    items: [
      { short: "“我还年轻。”", title: "“我还年轻，以后再安排就好。”", copy: "传承规划不只与年龄有关。真正的问题是：如果生活突然发生变化，是否有人能够清楚行动，而您所爱的人是否知道该怎么做。" },
      { short: "“我已经有遗嘱了。”", title: "“我有遗嘱，所以一切都安排好了。”", copy: "遗嘱很重要，但它无法涵盖所有资产与实际安排。CPF 提名、遗嘱执行人安排、资产持有方式以及最新资产清单，各自承担不同作用。" },
      { short: "“我的家人都知道。”", title: "“我的家人知道我想要什么。”", copy: "沟通很重要，但当事情真正发生时，家人仍可能需要有效文件、正式授权与准确资料，才能顺利执行您的意愿。" },
      { short: "“我的资产没有很多。”", title: "“我的资产不多，不需要做传承规划。”", copy: "传承规划并非富人的专利。即使资产不多，也可能涉及 CPF 储蓄、保险、房产、数码账户、个人意愿、遗嘱执行责任与家人实际安排。" },
    ],
  },
  journey: {
    eyebrow: "您的清晰规划之旅",
    title: "四个关键对话，一幅更清晰的全貌。",
    lead: "讲座将带您从“我知道应该做点什么”，一步步走到“我知道接下来该先检查什么”。",
    duration: "华语 Zoom 线上讲座 · 60分钟 · 全程线上",
    takeaway: "您将带走",
    steps: [
      { title: "看见缺口", copy: "了解遗嘱、提名、遗嘱执行人角色与资产整理如何互相配合。", outcome: "把零散文件，连成一幅完整规划。", detail: "看懂遗嘱、提名、遗嘱执行人角色与资产资料之间的联系，并发现家人可能面对的关键缺口。" },
      { title: "分清角色", copy: "厘清遗嘱执行人、监护人、被提名人与受益人的实际差别。", outcome: "为不同责任，选择真正合适的人。", detail: "分清遗嘱执行人、监护人、被提名人与受益人的责任，让每个人都知道自己能做什么、不能做什么。" },
      { title: "打破假设", copy: "检视“家人应该知道”与“有遗嘱就够了”等常见盲点。", outcome: "用清晰可找的安排，取代想当然。", detail: "在压力出现之前，重新检视“遗嘱涵盖一切”或“家人都知道”等常见想法。" },
      { title: "决定下一步", copy: "带走一份涵盖沟通、文件与专业协助的实用清单。", outcome: "离开讲座时，清楚知道第一步。", detail: "运用简单清单，决定哪些对话、文件与专业意见值得优先处理。" },
    ],
  },
  video: {
    eyebrow: "一段值得听见的话",
    title: "这不是在计划死亡。",
    lead: "这是为了让未来可能替您执行意愿的人，少一点压力，多一份清晰。",
    note: "以下为过往实体讲座的精彩回顾与学员分享。线上讲座内容与实体讲座相同。",
    points: ["为什么拥有多份文件，不代表已经形成完整规划", "家人往往等到无法再提问时，才发现缺少哪些答案", "如何在不被法律或财务术语压倒的情况下，轻松踏出第一步"],
    button: "参加下一场华语讲座",
    caption: "遗嘱与财富传承规划 · 过往实体讲座回顾",
    quotesTitle: "学员心声",
    quotes: [
      { text: "原本以为立了遗嘱就万无一失，听完才明白公积金提名、保险与遗嘱必须互相配合，缺一不可。", who: "学员 · 2025年7月实体讲座" },
      { text: "讲解清楚、贴近生活，没有难懂的术语。回家后终于知道该先和家人谈什么、先整理哪些文件。", who: "学员 · 2025年7月实体讲座" },
      { text: "两个小时非常值得。我们第一次把执行人、监护人与受益人的角色真正分清楚了。", who: "学员 · 实体讲座" },
    ],
  },
  readiness: {
    eyebrow: "60秒自我检视",
    title: "您目前的规划有多清晰？",
    lead: "勾选每一项您今天能够肯定的陈述。这只是自我检视工具，并非法律或财务评估。",
    checks: ["我的遗嘱符合目前的家庭状况与意愿。", "我的 CPF 提名是最新的。", "我已选择合适的遗嘱执行人，并与对方谈过这份责任。", "我信任的人能够找到我的重要资料。", "我指定的人清楚了解自己的角色。"],
    confident: "确定属实",
    scoreOf: "项清晰 / 共5项",
    scoreNote: "仅供自我检视 · 不会储存任何资料",
    button: "保留我的线上讲座席位",
    scores: [
      ["仍有空间建立更多清晰。", "您不需要准备好所有答案才来参加。这场讲座正是为了帮助您找出值得优先思考的问题。"],
      ["这是很有价值的第一步。", "您已经开始思考传承规划；讲座将帮助您看见还有哪些相互关联的部分值得关注。"],
      ["您已经打下一些基础。", "接下来可检视现有安排是否仍符合目前的家庭、资产与个人意愿。"],
      ["您正在建立更清晰的规划。", "您的基础已逐渐完整；讲座将帮助您检查各项安排是否真正衔接。"],
      ["您的准备程度相当不错。", "即使规划充分，经历人生重大变化或角色关系改变后，也值得重新检视。"],
      ["您已考虑到主要环节。", "把这场讲座当作一次实用复盘，并带上关于持续更新规划的疑问。"],
    ],
  },
  speaker: {
    eyebrow: "华语主讲人",
    title: "复杂的传承课题，也可以讲得清楚易懂。",
    lead: "两位兼具专业资格、实战经验与家庭视角的讲者，分别主讲两场华语讲座，引导您看见真正重要的规划问题。",
    sessionSuffix: { one: "场", many: "场" },
    people: [
      {
        id: "vincent",
        tag: "华语讲座主讲人",
        name: "Vincent Chua 蔡镇安 | CFP®, ChFC®",
        role: "资深财务顾问经理 · Affinity Group",
        rnf: "RNF: CTA300278121",
        initials: "VC",
        portrait: "/speaker-vincent.jpg",
        portraitFit: "portrait-cover",
        bio: "蔡镇安是一位兼具专业深度与实战经验的资深财务顾问经理，拥有近十年财务规划经验，并持有新加坡注册财务规划师（CFP®）及特许财务顾问（ChFC®）资格。作为 Affinity Group 的遗产规划师，他擅长将复杂的财富传承课题化繁为简，协助家庭梳理遗嘱、CPF 提名、遗嘱执行人角色与资产安排之间的关键联系。目前，他亦带领团队，以清晰、务实且贴近生活的方式，帮助个人与家庭建立更完整、更长远的财富传承规划。对他而言，遗产规划从来不只是关于离开，而是在人生尚能作主时，为所爱的人留下秩序、方向与安心。",
        focus: ["遗嘱规划", "CPF 提名", "遗嘱执行人与受益人角色", "资产整理"],
      },
      {
        id: "fion",
        tag: "华语讲座主讲人",
        name: "Fion Yong 杨炎芬",
        role: "财富顾问 Wealth Consultant · Affinity Group",
        rnf: "RNF: YYF300143021",
        initials: "FY",
        portrait: "/speaker-fion.jpg",
        portraitFit: "portrait-cover",
        bio: "拥有超过13年的理财规划经验，Fion 致力于协助个人及家庭应对人生不同阶段的财务挑战，涵盖保障规划、财富累积及财富传承。她热衷于将复杂的理财概念化繁为简，并透过社交媒体持续分享实用且容易理解的理财知识。她希望帮助更多家庭守护辛苦建立的财富，并确保自己的意愿能够顺利传承给下一代。因为真正的传承，不在于我们留下多少财富，而在于当我们不在的时候，所爱的人是否依然得到妥善的照顾与保护。",
        focus: ["保障规划", "财富累积", "财富传承", "意愿与遗嘱安排"],
      },
    ],
  },
  mid: { title: "整理意愿最好的时候，就是每一个选择仍掌握在自己手中的现在。", button: "保留我的免费线上席位" },
  sessions: {
    eyebrow: "选择您的线上讲座场次",
    title: "选择适合您的日期与语言。",
    lead: "所有场次均为免费 Zoom 线上直播，时长约一小时（新加坡时间上午10时至11时）。英文场由 Nicholas Lee 主讲；华语场分别由 Vincent Chua 蔡镇安（9月19日）及 Fion Yong 杨炎芬（11月21日）主讲。",
    englishGroup: "英文场 · Nicholas Lee",
    chineseGroup: "华语场 · Vincent Chua 蔡镇安 & Fion Yong 杨炎芬",
    time: "上午10时 – 11时（新加坡时间）",
    reserve: "预留此线上场次",
    format: "Zoom 线上直播讲座 · 任何地点均可参加",
  },
  faq: {
    eyebrow: "报名之前还有疑问？",
    title: "从这里开始。",
    lead: "如果这里没有您的问题，欢迎先保留席位，并在现场问答环节提出。",
    items: [
      { q: "这是实体讲座还是线上讲座？", a: "这是 100% 线上讲座，通过 Zoom 直播，没有实体场地，也无需出门。您可在家中或新加坡任何地点，用手机、平板或电脑参加。报名后，您的专属 Zoom 参加链接会发送到您的电邮，讲座前一天也会再次发送提醒。" },
      { q: "这场讲座只适合年长人士吗？", a: "不会。只要您拥有重视的人、责任、资产或重要决定，传承规划就与您有关。许多人会在结婚、生儿育女、买房或承担照护责任后开始规划。" },
      { q: "我已经有遗嘱了，讲座仍然适合我吗？", a: "适合。讲座不只谈遗嘱，也会涵盖 CPF 提名、遗嘱执行人与受益人角色、资产资料，以及经历重大人生变化后重新检视规划的重要性。" },
      { q: "讲座会提供个人法律或财务建议吗？", a: "不会。讲座提供的是一般教育资讯。采取任何行动前，您仍应根据个人情况寻求独立的财务、法律、税务或其他专业意见。" },
      { q: "我需要具备任何基础知识吗？", a: "不需要。内容专为一般新加坡家庭设计，以清晰、实用的华语讲解。报名时，您也可以提交最想了解的问题。" },
      { q: "我会如何收到线上讲座链接？", a: "报名后，确认与参加方式将发送到您提供的电邮地址或手机号码。如果没有收到，请检查垃圾邮件或促销邮件文件夹。" },
    ],
  },
  register: {
    eyebrow: "保留线上讲座席位",
    title: ["为家人留下比资产更珍贵的东西：", "清晰与安心。"],
    lead: "参加下一场免费华语线上讲座，为家人能够理解并顺利执行的传承规划，踏出第一步。",
    chooseDate: "选择日期",
    dateLabel: "日期",
    timeLabel: "时间",
    venueLabel: "方式",
    time: "上午10时 – 11时（新加坡时间）",
    venue: "Zoom 线上直播（非实体活动）",
    speakerLabel: "主讲",
    langTag: { English: "英文场", Chinese: "华语场" },
    countdown: ["天", "小时", "分钟", "秒"],
    steps: ["保留席位", "补充资料"],
    labels: { name: "姓名", email: "电邮地址", mobile: "手机号码", session: "选择场次", question: "您最想了解的遗嘱与传承规划问题", invitedBy: "邀请人", ageRange: "您的年龄段" },
    ageRanges: { under30: "30岁以下", "30s": "30 – 39岁", "40s": "40 – 49岁", "50s": "50 – 59岁", "60plus": "60岁及以上" },
    placeholders: { name: "例如：陈伟明", email: "you@example.com", mobile: "8123 4567", other: "点选上方主题，或输入您自己的问题", invitedBy: "邀请您参加的人的姓名" },
    mobilePrefix: "+65",
    optional: "（可选）",
    invitedByLocked: "已根据您顾问的邀请链接自动填入。",
    continue: "继续",
    back: "返回",
    privacyNote: "提交此表格即表示您同意我们就您的报名及活动资讯与您联系。",
    questions: {
      will: "拟定或更新遗嘱",
      cpf: "办理或检视 CPF 提名",
      roles: "遗嘱执行人、监护人与受益人角色",
      assets: "整理资产与重要记录",
      review: "检查现有传承规划是否完整",
      unsure: "我不确定自己的传承规划有哪些缺口",
      other: "其他",
    },
    consent: "我已阅读上述声明，并同意 Affinity Group 为所述目的收集及使用我的个人资料。",
    pdpa: {
      intro: "当您向我们提供个人资料（即姓名、电邮地址及电话号码），即表示您确认并同意我们为以下目的收集您的个人资料：",
      purposes: [
        "通过电话、短信或电邮向您发送与本网站内容相关的营销、广告或推广资讯；",
        "提供您所要求的产品与服务。",
      ],
      withdraw: "请注意，您有权随时撤回对我们收集您个人资料的同意，只需发送通知至 ",
      email: "marketing@affinitygroup.sg",
    },
    submit: "保留我的线上讲座席位",
    reassurance: "免费参加 · 无任何购买义务 · 您的资料将被保密",
    messages: {
      required: "请先填写所有必填项目。",
      mobile: "请输入有效的8位新加坡手机号码。",
      email: "请输入有效的电邮地址。",
      consent: "请勾选同意选项以继续。",
      ageRange: "请选择您的年龄段。",
      submitting: "正在为您保留席位…",
      success: "您的席位已保留。请查看电邮中的确认与参加详情。",
      duplicate: "此电邮已报名所选场次，期待与您相见！",
      failed: "暂时无法完成报名，请重试或联系 Affinity Group 团队。",
    },
    successHeading: "您的席位已保留。",
    successMeta: "确认电邮已发出。Zoom 参加链接将在讲座前发送给您。",
    another: "为他人报名",
    share: {
      kicker: "身边有人也需要了解这些吗？",
      button: "通过 WhatsApp 分享",
      message: "您好！我刚报名了 Affinity Group 主办的免费《遗嘱与传承规划》线上讲座（{date}，{time}，Zoom 直播）。觉得对您也会有帮助，欢迎一起参加，报名链接：{url}",
    },
    calendar: {
      heading: "加入您的日历",
      title: "遗嘱与财富传承规划线上讲座 · Affinity Group",
      details: "您已成功报名参加 Affinity Group 的《遗嘱与财富传承规划》免费线上讲座（上午10时 – 11时 新加坡时间，Zoom 线上直播）。Zoom 参加链接将在讲座前通过电邮发送给您。",
      google: "Google",
      apple: "Apple / iCal",
      outlook: "Outlook",
    },
  },
  footer: {
    links: ["隐私政策", "使用条款", "常见问题"],
    blurb: "协助个人与家庭更清楚地了解自身的保障、长期护理与财务规划需求。",
    connect: "关注我们",
    quickLinksTitle: "快速链接",
    quickLinks: [
      { label: "讲座内容", href: "#learn" },
      { label: "观看视频", href: "#watch" },
      { label: "主讲人", href: "#speakers" },
      { label: "常见问题", href: "#faq" },
      { label: "保留席位", href: "#register" },
    ],
    whatsappMessage: "您好，我想询问即将举行的遗嘱与财富传承规划线上讲座。",
    disclaimer: "Affinity Group 是代表 Infinity Financial Advisory Pte. Ltd. 的财务顾问代表团队。本讲座及网站仅提供一般资讯与教育内容，不构成财务、法律、税务、会计或遗产规划建议，也不构成任何金融产品的要约或推荐。资料可能并不完整或不适合您的个人情况。作出任何决定前，请向具备适当资格的专业人士寻求意见。报名须视席位与最终确认为准。",
    rights: "Affinity Group。保留所有权利。",
  },
  sticky: { mobileTitle: "免费线上讲座", desktopKicker: "下一场讲座", reserve: "保留线上席位", reserveLong: "保留线上讲座席位" },
};

export default zh;
